/**
 * Validates an ABA routing number using the checksum algorithm.
 *
 * The ABA routing number is a 9-digit code used to identify financial
 * institutions in the United States. This function validates the number
 * using the standard checksum formula.
 *
 * @param routingNumber - The 9-digit routing number to validate
 * @returns `true` if the routing number is valid, `false` otherwise
 */
export function isValidRoutingNumber(routingNumber: string): boolean {
  if (!/^\d{9}$/.test(routingNumber)) {
    return false;
  }

  const digits = routingNumber.split("").map(Number);
  const checksum =
    3 * (digits[0] + digits[3] + digits[6]) +
    7 * (digits[1] + digits[4] + digits[7]) +
    (digits[2] + digits[5] + digits[8]);

  return checksum % 10 === 0;
}
